module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Watch#2-df7b5eb560a5895919e1c7778e20f036.svg";